import { Ban, LogOut } from "lucide-react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import Button from "../ui/Button";
import { performLogout } from "../../utils/authSession";
import { isAccountRestricted } from "../../utils/accountStatus";

export { isAccountRestricted };

const STATUS_COPY = {
  inactive: {
    title: "Account inactive",
    reason:
      "Your institution account is inactive. You can sign in, but portal browsing is paused until SimCollect reactivates you.",
  },
  suspended: {
    title: "Account suspended",
    reason:
      "Your institution account has been suspended. Access to portfolios and cases is blocked. Contact SimCollect support for help.",
  },
};

export default function AccountRestrictedModal() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.user);
  const token = useSelector((state) => state.auth.token);

  if (!isAccountRestricted(user)) return null;

  const status = String(user.status).toLowerCase();
  const copy = STATUS_COPY[status] ?? STATUS_COPY.inactive;
  const reason = user.status_reason || copy.reason;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-primary-dark/70 p-4 backdrop-blur-md">
      <div
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="account-restricted-title"
        className="w-full max-w-md overflow-hidden rounded-2xl bg-white shadow-2xl"
      >
        <div className="h-1 bg-gradient-to-r from-collect via-accent to-collect" aria-hidden />
        <div className="px-6 py-7 text-center">
          <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-collect/[0.08] text-collect">
            <Ban className="h-7 w-7" />
          </span>
          <h2 id="account-restricted-title" className="mt-4 text-xl font-bold text-primary">
            {copy.title}
          </h2>
          <p className="mt-2 text-sm leading-relaxed text-primary/55">{reason}</p>
          <p className="mt-3 text-xs font-semibold text-primary/40">
            Signed in as {user?.name} · {user?.email}
          </p>
          <Button
            className="mt-6 w-full"
            size="lg"
            onClick={async () => {
              await performLogout(dispatch, token);
              navigate("/login", { replace: true });
            }}
          >
            <LogOut className="h-4 w-4" />
            Log out
          </Button>
        </div>
      </div>
    </div>
  );
}
